import {
	WORKCYCLE_BEGIN,
	WORKCYCLE_SUCCESS,
	WORKCYCLE_FAILURE,
	CLEAR_WORKCYCLE,

	FILTER_BEGIN,
	FILTER_SUCCESS,
	FILTER_FAILURE,
	FILTER_CLEAR,

	COMMUNICATION_DISPATCH_BEGIN,
	COMMUNICATION_DISPATCH_SUCCESS,
	COMMUNICATION_DISPATCH_FAILURE,
	COMMUNICATION_DISPATCH_CLEAR,
	FIELDS_FILTERS_WORK_CYCLE_SUCCESS,
} from 'app/actions/WorkCycleActions';

const initialState = {
	byId: {},
	allIds: [],
	filterData: [],
	isLoading: false,
	evaluationData: [],
	listSubdirectionEvaluationData: [],
	listContractEvaluationData: [],
	listWorkEvaluationData: [],
	listCommunicationProgramData: [],
	listFrontEvaluationData: [],
	listEmployeeEvaluationData: [],
	listTestEvaluationData: [],
};

export default function WorkCycleReducer(state = initialState, action) {
	switch (action.type) {
		case WORKCYCLE_BEGIN:
			return {
				...state,
				isLoading: true
			}
		case WORKCYCLE_SUCCESS:
			let allIds = action.payload.data;
			let byId = {
				...state.byId,
			};
			return {
				...state,
				allIds,
				byId,
				isLoading: false,
			};
		case CLEAR_WORKCYCLE:
			return {
				...state,
				byId: {},
				allIds: [],
				isLoading: false,
			}
		case WORKCYCLE_FAILURE:
			return {
				...state,
				isLoading: false
			}
		//FILTER
		case FILTER_BEGIN:
			return {
				...state,
				isLoading: true
			}
		case FILTER_SUCCESS:
			let filterData = [...new Set(state.filterData.concat(action.payload.filterData))];
			return {
				...state,
				filterData,
				isLoading: false,
			};
		case FILTER_CLEAR:
			return {
				...state,
				filterData: [],
				isLoading: false,
			}
		case FILTER_FAILURE:
			return {
				...state,
				isLoading: false
			}
		//Evaluation
		case COMMUNICATION_DISPATCH_BEGIN:
			return {
				...state,
				isLoading: true
			}
		case COMMUNICATION_DISPATCH_SUCCESS:

			let evaluationData = action.payload.filterData.Data === null ? [] : action.payload.filterData.Data;
			return {
				...state,
				evaluationData,
				isLoading: false,
			};
		case COMMUNICATION_DISPATCH_CLEAR:
			return {
				...state,
				evaluationData: [],
				isLoading: false,
			}
		case COMMUNICATION_DISPATCH_FAILURE:
			return {
				...state,
				isLoading: false
			}
		case FIELDS_FILTERS_WORK_CYCLE_SUCCESS:
			
			if (action.payload.filterData.Data != null) {
				let listEmployeeEvaluationDataTemp = action.payload.filterData.Data.map(x => { return { employeeId: x.employeeId, employeeName: x.employeeName } }).filter(y => y.employeeId !== null)
				listEmployeeEvaluationDataTemp.unshift({ employeeId: 'N/A', employeeName: 'N/A' })
				return {
					...state,
					listSubdirectionEvaluationData: action.payload.filterData.Data.map((x) => { return { idSubdirection: x.idSubdirection, subdirectionName: x.subdirectionName } }).filter(y => y.idSubdirection !== null),
					listContractEvaluationData: action.payload.filterData.Data.map(x => { return { idContract: x.idContract, contractName: x.contractName } }).filter(y => y.idContract !== null),
					listWorkEvaluationData: action.payload.filterData.Data.map(x => { return { idWork: x.idWork, workName: x.workName } }).filter(y => y.idWork !== null),
					listCommunicationProgramData: action.payload.filterData.Data.map(x => { return { idCommunicationProgram: x.idCommunicationProgram, communicationProgramName: x.communicationProgramName } }).filter(y => y.idCommunicationProgram !== null),
					listFrontEvaluationData: action.payload.filterData.Data.map(x => { return { idFront: x.idFront, frontName: x.frontName } }).filter(y => y.idFront !== null),
					listEmployeeEvaluationData: listEmployeeEvaluationDataTemp,
					listTestEvaluationData: action.payload.filterData.Data.map(x => { return { idTest: x.idTest, testTitle: x.testTitle } }).filter(y => y.idTest !== null),
					isLoading: false,
				};
			}

		default:
			return state;
	}
};

export const getWorkCycle = state => {
	return state.allIds;
}
export const getIsLoadingWorkCycle = state => {
	return state.isLoading;
}

export const getWorkCycleFilter = state => {
	return state.filterData
}
export const getIsLoadingWorkCycleFilter = state => {
	return state.isLoading;
}

export const getWorkCycleEvaluation = state => {
	return state.evaluationData
}
export const getIsLoadingWorkCycleEvaluation = state => {
	return state.isLoading;
}

export const getListSubdirectionEvaluationData = state => {
	return state.listSubdirectionEvaluationData;
}

export const getListContractEvaluationData = state => {
	return state.listContractEvaluationData;
}

export const getListWorkEvaluationData = state => {
	return state.listWorkEvaluationData;
}
export const getListFrontEvaluationData = state => {
	return state.listFrontEvaluationData;
}
export const getListEmployeeEvaluationData = state => {
	return state.listEmployeeEvaluationData;
}
export const getListTestEvaluationData = state => {
	return state.listTestEvaluationData;
}
export const getListCommunicationProgramData = state => {
	return state.listCommunicationProgramData;
}